<template>
  <div class="notifications-list">
    <transition-group name="notification" tag="div">
      <Notification
        v-for="notification in notifications"
        :key="notification.id"
        :id="notification.id"
        :type="notification.type"
        :title="notification.title"
        :message="notification.message"
        :duration="notification.duration"
        @remove="handleRemoveNotification"
      />
    </transition-group>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Notification from '../notification';

export default {
  components: { Notification },
  computed: {
    ...mapGetters('notificationModule', ['allNotifications']),
    notifications() {
      return this.allNotifications;
    },
  },
  methods: {
    ...mapActions('notificationModule', ['removeNotification']),
    handleRemoveNotification(id) {
      this.removeNotification(id);
    },
  },
};
</script>

<style lang="scss" scoped>
.notifications-list {
  font-family: 'Geist', sans-serif;
  font-size: 14px;
  color: #09090B;

  position: fixed;
  top: 12px;
  right: 12px;
  width: 100%;
  max-width: 420px;
  z-index: 250;
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: 450px) {
    max-width: 300px;
  }
}

.notification-enter-active,
.notification-leave-active {
  transition: all 0.5s ease;
}

.notification-enter, .notification-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.notification-leave-active {
  position: absolute;
  width: 100%;
}

.notification-move {
  transition: transform 0.5s ease;
}
</style>
